angular.module("acl.visualizer.mapChart", [
  "acl.visualizer.charts.controllers",
  "acl.visualizer.charts",
  "acl.visualizer.color",
  "acl.common.localize",
]);
